<script>
export default {}
</script>

<template>
  <div class="header__main">
    <div class="header__brand">
      <div class="header__logo-container">
        <router-link :to="{ name: 'home' }">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134 41.32">
            <defs></defs>
            <g class="cls-1">
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    class="cls-2"
                    d="M54.26,27.84V21.71H48.48v6.13H45.92V13.77h2.56v5.5h5.78v-5.5h2.56V27.84Z"
                  />
                  <g class="cls-3">
                    <path
                      class="cls-2"
                      d="M54.26,27.84V21.71H48.48v6.13H45.92V13.77h2.56v5.5h5.78v-5.5h2.56V27.84Z"
                    />
                  </g>
                  <path
                    class="cls-2"
                    d="M59.49,27.84V13.77h9.6v2.32H62v3.28H68.2v2.3H62v3.84h7.05v2.33Z"
                  />
                  <g class="cls-3">
                    <path
                      class="cls-2"
                      d="M59.49,27.84V13.77h9.6v2.32H62v3.28H68.2v2.3H62v3.84h7.05v2.33Z"
                    />
                  </g>
                  <path
                    class="cls-2"
                    d="M79.43,27.84l-3.15-5.12-3.16,5.12H70.37l4.42-7.17-4.39-6.9h2.8l3.16,4.92,3-4.92h2.78l-4.33,6.92,4.39,7.15Z"
                  />
                  <g class="cls-3">
                    <path
                      class="cls-2"
                      d="M79.43,27.84l-3.15-5.12-3.16,5.12H70.37l4.42-7.17-4.39-6.9h2.8l3.16,4.92,3-4.92h2.78l-4.33,6.92,4.39,7.15Z"
                    />
                  </g>
                  <path
                    class="cls-2"
                    d="M92.4,27.84l-.91-2.7h-5.6L85,27.84H82.4l4.94-14.07h2.8l4.94,14.07ZM88.69,16.9l-2,5.94h4Z"
                  />
                  <g class="cls-3">
                    <path
                      class="cls-2"
                      d="M92.4,27.84l-.91-2.7h-5.6L85,27.84H82.4l4.94-14.07h2.8l4.94,14.07ZM88.69,16.9l-2,5.94h4Z"
                    />
                  </g>
                  <path
                    class="cls-2"
                    d="M106.61,27.84l-1.49-1.55a4.12,4.12,0,0,1-3.53,1.8,5.41,5.41,0,0,1-4.19-1.56c-1.46-1.53-1.82-3.42-1.82-5.72s.3-4.12,1.83-5.65a6,6,0,0,1,4.18-1.65,5.82,5.82,0,0,1,4.17,1.61A4.34,4.34,0,0,1,107.05,18h-2.62a2.19,2.19,0,0,0-.62-1.29,2.8,2.8,0,0,0-2.24-.86,3.32,3.32,0,0,0-2.3,1c-1,1-1.09,2.76-1.09,4s.14,3.1,1.11,4.11a3.24,3.24,0,0,0,2.28.89,2.85,2.85,0,0,0,2.11-.81,3.62,3.62,0,0,0,.91-2.74h-3.36V20.14h5.84v7.7Z"
                  />
                  <g class="cls-3">
                    <path
                      class="cls-2"
                      d="M106.61,27.84l-1.49-1.55a4.12,4.12,0,0,1-3.53,1.8,5.41,5.41,0,0,1-4.19-1.56c-1.46-1.53-1.82-3.42-1.82-5.72s.3-4.12,1.83-5.65a6,6,0,0,1,4.18-1.65,5.82,5.82,0,0,1,4.17,1.61A4.34,4.34,0,0,1,107.05,18h-2.62a2.19,2.19,0,0,0-.62-1.29,2.8,2.8,0,0,0-2.24-.86,3.32,3.32,0,0,0-2.3,1c-1,1-1.09,2.76-1.09,4s.14,3.1,1.11,4.11a3.24,3.24,0,0,0,2.28.89,2.85,2.85,0,0,0,2.11-.81,3.62,3.62,0,0,0,.91-2.74h-3.36V20.14h5.84v7.7Z"
                    />
                  </g>
                  <path
                    class="cls-2"
                    d="M119,26.51a6,6,0,0,1-8.09,0c-1.53-1.53-1.79-3.4-1.79-5.7s.26-4.18,1.79-5.71a5.94,5.94,0,0,1,8.09,0c1.53,1.53,1.79,3.41,1.79,5.71S120.54,25,119,26.51Zm-1.82-9.75a3.16,3.16,0,0,0-2.23-.93,3.12,3.12,0,0,0-2.22.93c-1,1-1,2.76-1,4s0,3,1,4a3.08,3.08,0,0,0,2.22.93,3.12,3.12,0,0,0,2.23-.93c1-1,1-2.74,1-4S118.16,17.78,117.19,16.76Z"
                  />
                  <g class="cls-3">
                    <path
                      class="cls-2"
                      d="M119,26.51a6,6,0,0,1-8.09,0c-1.53-1.53-1.79-3.4-1.79-5.7s.26-4.18,1.79-5.71a5.94,5.94,0,0,1,8.09,0c1.53,1.53,1.79,3.41,1.79,5.71S120.54,25,119,26.51Zm-1.82-9.75a3.16,3.16,0,0,0-2.23-.93,3.12,3.12,0,0,0-2.22.93c-1,1-1,2.76-1,4s0,3,1,4a3.08,3.08,0,0,0,2.22.93,3.12,3.12,0,0,0,2.23-.93c1-1,1-2.74,1-4S118.16,17.78,117.19,16.76Z"
                    />
                  </g>
                  <path
                    class="cls-2"
                    d="M131.36,27.84l-6.09-9.67v9.67h-2.52V13.77h2.72l6,9.52V13.77H134V27.84Z"
                  />
                  <g class="cls-3">
                    <path
                      class="cls-2"
                      d="M131.36,27.84l-6.09-9.67v9.67h-2.52V13.77h2.72l6,9.52V13.77H134V27.84Z"
                    />
                  </g>
                  <polygon
                    class="cls-4"
                    points="17.89 30.99 17.89 41.32 23.86 30.99 17.89 30.99"
                  />
                  <polygon
                    class="cls-4"
                    points="5.96 20.66 0 30.99 8.95 25.82 5.96 20.66"
                  />
                  <polygon
                    class="cls-5"
                    points="0 30.99 11.93 30.99 8.95 25.82 0 30.99"
                  />
                  <polygon
                    class="cls-5"
                    points="23.86 30.99 35.78 10.33 17.89 20.66 17.89 30.99 23.86 30.99"
                  />
                  <polygon
                    class="cls-6"
                    points="17.89 41.32 35.78 30.99 23.86 30.99 17.89 41.32"
                  />
                  <polygon
                    class="cls-6"
                    points="8.95 25.82 17.89 20.66 17.89 0 5.96 20.66 8.95 25.82"
                  />
                  <polygon
                    class="cls-6"
                    points="11.93 30.99 17.89 41.32 17.89 30.99 11.93 30.99"
                  />
                  <polygon
                    class="cls-5"
                    points="0 10.33 0 30.99 5.96 20.66 0 10.33"
                  />
                  <polygon
                    class="cls-7"
                    points="35.78 10.33 23.86 30.99 35.78 30.99 35.78 10.33 35.78 10.33"
                  />
                  <polygon
                    class="cls-7"
                    points="17.89 20.66 8.95 25.82 11.93 30.99 17.89 30.99 17.89 20.66"
                  />
                  <polygon
                    class="cls-7"
                    points="17.89 0 0 10.33 5.96 20.66 17.89 0"
                  />
                </g>
              </g>
            </g>
          </svg>
        </router-link>
      </div>
      <div class="header__title">Life of Mine</div>
    </div>
  </div>
</template>

<style lang="scss">
/* stylelint-disable */
.cls-1 {
  isolation: isolate;
}
.cls-2 {
  fill: #fff;
}
.cls-3 {
  mix-blend-mode: multiply;
  opacity: 0.3;
}
.cls-4 {
  fill: none;
}
.cls-5 {
  fill: #77c2d4;
}
.cls-6 {
  fill: #bad97a;
}
.cls-7 {
  fill: #0098ba;
}
</style>
